import React from "react";
import useFetch from "@/lib/useFetch";
import { PageHeader, Footer, SectionCard } from "@/components/common/Page";
import Loader from "@/components/common/Loader";
import { Key, Gamepad2, Globe } from "lucide-react";

export default function Roles() {
    const { data } = useFetch("/discord/role-mappings");
    if (!data) return <Loader />;

    const byRole = Object.fromEntries(data.mappings.map((m) => [m.outpost_role, m]));

    return (
        <div data-testid="admin-roles">
            <PageHeader title="Roles" subtitle="Outpost Network roles and their Discord mappings. Edit mappings in Discord → Role Mapping." />
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
                <SectionCard title="Network Roles">
                    <div className="space-y-2">
                        {data.outpost_roles.map((r) => (
                            <RoleRow key={r} icon={Key} name={r} mapped={byRole[r]} />
                        ))}
                    </div>
                </SectionCard>
                <SectionCard title="Platform Roles">
                    <div className="space-y-2">
                        {data.platform_roles.map((r) => (
                            <RoleRow key={r} icon={Gamepad2} name={r} mapped={byRole[r]} />
                        ))}
                    </div>
                </SectionCard>
                <SectionCard title="Community Roles">
                    <div className="space-y-2">
                        {["Coder's Playground", "Haven & Havoc", "The Hideout"].map((r) => (
                            <RoleRow key={r} icon={Globe} name={r} mapped={byRole[r]} />
                        ))}
                    </div>
                </SectionCard>
            </div>
            <Footer />
        </div>
    );
}

function RoleRow({ icon: Icon, name, mapped }) {
    return (
        <div className="flex items-center justify-between rounded-md border border-border bg-background/40 p-2.5">
            <div className="flex items-center gap-2">
                <Icon size={14} className="text-hazard" />
                <span className="font-heading font-semibold uppercase text-foreground">{name}</span>
            </div>
            <span className={`label-mono ${mapped ? "text-radioactive" : "text-muted-foreground"}`}>
                {mapped ? mapped.discord_role_name : "unmapped"}
            </span>
        </div>
    );
}
